import VTab from './VTab'
import VTabs from './VTabs'

export default {
  VTab,
  VTabs
}
